<template>
  <el-header>
    <section class="header-left"><i @click="foldSidebar" class="header-func" :class="iconFold" /></section>
    <section class="header-right">
      <el-dropdown @command="(item) => {handleCommand(item)}">
        <span class="el-dropdown-link">
          {{ currentCompany }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, index) in userCompanyRelRespList" :key="index" :command="item">{{item.companyName}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span @click="pageBack" class="header-func1">返回首页</span>
      <!-- <i @click="pageBack" class="header-func el-icon-back" /> -->
      <i @click="pageRefresh" class="header-func el-icon-refresh" />
      <div class="header-person">
        <i class="header-func el-icon-user-solid" />
        <p>{{ userName }} - {{ accountName }} <i class="el-icon-arrow-down" /></p>
        <ul class="down-list">
          <li @click="logout">退出</li>
        </ul>
      </div>
    </section>
  </el-header>
</template>

<script>
// @ is an alias to /src
import { loginOut, bindTokenCompanyIdAfterLogin } from '@/api/user'
import { mapState } from 'vuex'

export default {
  name: 'home',
  data () {
    return {
      accountName: '用户名',
      userName: '',
      currentCompany: '',
      userCompanyRelRespList: []
    }
  },
  computed: mapState({
    iconFold: (state) => state.sidebarSwitch ? 'el-icon-s-fold' : 'el-icon-s-unfold'
  }),
  mounted () {
    this.accountName = this.$base.getLocalStorage('userInfo_roleName')
    this.userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName || ''
    this.userCompanyRelRespList = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo_userCompanyRelRespList')) || ''
    if (this.$base.getLocalStorage('current_company')) {
      let currentCompanyItem = JSON.parse(this.$base.getLocalStorage('current_company'))
      this.currentCompany = currentCompanyItem.companyName
      this.handleChangeCompany(currentCompanyItem.companyId)
    } else {
      this.currentCompany = this.userCompanyRelRespList[0].companyName
      this.handleChangeCompany(this.userCompanyRelRespList[0].companyId)
      this.$base.setLocalStorage('current_company', this.userCompanyRelRespList[0])
    }
  },
  methods: {
    foldSidebar () {
      this.$store.commit('changeSidebarStatus', !this.$store.state.sidebarSwitch)
    },
    pageRefresh () {
      window.location.reload()
    },
    pageBack () {
      this.$router.push('/home')
    },
    logout () {
      this.$confirm('是否确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        loginOut().then((res) => {
          if (res.code === 0) {
            localStorage.setItem('jiadingFangwu_token', '')
            window.localStorage.removeItem('userPageInfo')
            localStorage.clear()
            this.$router.push('/home')
            // this.$message({
            //   type: 'success',
            //   message: '退出成功!'
            // })
          }
        })
      })
    },
    async handleCommand(item) {
      this.currentCompany = item.companyName
      this.$base.setLocalStorage('current_company', item)
      await this.handleChangeCompany(item.companyId)
      await this.pageRefresh()
    },
    async handleChangeCompany(companyId) {
      // setTimeout(async () => {
        await bindTokenCompanyIdAfterLogin({ companyId: companyId })
      // }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
$bkColor: #333;
.el-header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: .6rem!important;
  line-height: .6rem;
  padding: 0;
  .header-func {
    /*display: block;*/
    font-size: .22rem;
    color: #7E8BAB;
    cursor: pointer;
  }
  .header-left {
    padding-left: .2rem;
  }
  .header-right {
    .el-dropdown-link{
      font-size: 12px;
      margin-right: 20px;
    }
    .header-func {
      margin-right: .2rem;
    }
    .header-func1 {
      margin-right: .2rem;
        color: #666;
        cursor: pointer;
    }
    .header-person {
      position: relative;
      float: right;
      margin: 0 .3rem 0 .1rem;
      p {
        display: inline-block;
        color: #666;
      }
      .header-func {
        margin-right: .1rem;
        cursor: default;
      }
      .down-list {
        display: none;
        position: absolute;
        right: 0;
        top: .5rem;
        min-width: .6rem;
        background-color: #FFF;
        box-shadow: 1px 2px 3px rgba(0, 0, 0, .1);
        border-radius: 5px;
        text-align: center;
        z-index: 100;
        li {
          cursor: pointer;
        }
      }
      &:hover {
        .down-list {
          display: block;
        }
      }
    }
  }
}
</style>
